import { useEffect, useState } from 'react';
import { CustomTable, ModalWrapper, SweetAlert } from '../../../../components';
import useTable from '../../../../hooks/useTable.hook';
import {
  Columns,
  getSplitPaymentService,
  uploadPaymentReceiptService,
  deletePaymentReceiptService
} from '../../../../services/index.service';
import { t } from 'i18next';
import UploadReceipt from './upload';
import MediaPreview from './view';
import { modalNotification } from '../../../../utils';

function SplitPaymentDetails({ providerDiscountData }) {
  const [searchData, setSearchData] = useState('');
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState('');
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [receiptData, setReceiptData] = useState({});
  const [page, setPage] = useState({
    currentPage: 1,
    sizePerPage: 10,
  });
  const { currentPage, sizePerPage } = page;
  const [firstTimeFetch, setFirstTimeFetch] = useState(false);
  let bookingId = providerDiscountData?.id;
  let extraQuery = {
    bookingId,
  };
  // Extra update
  // let isAnotherTable = {
  //   sizePerPage: 10,
  //   page: 1,
  // };
  const [tableHandler, tableProps] = useTable(
    getSplitPaymentService,
    extraQuery,
    false,
    page // Extra update
  );
  const { data, isLoading, count, filter } = tableProps;
  const {
    onFilterChange,
    getData,
    onTableSort,
    onSearch,
    onRefresh,
  } = tableHandler;

  const handleUpload = (data) => {
    setModal('uploadReceipt')
    data.viewImageUrl = [data?.receiptUrl];
    setReceiptData(data);
    setShow(true);
  };

  const handleView = (data) => {
    setModal('mediaPreiview')
    setReceiptData(data);
    setShow(true)
  };

  const columns = Columns.splitPaymentColumn({
    onSort: onTableSort,
    data,
    onFilterChange: onFilterChange,
    filter: filter,
    page: currentPage,
    sizePerPage,
    handleView,
    handleUpload
  });

  const onCancel = () => {
    setModal('');
    setShow(false);
    setReceiptData({});
  };

  async function handleActionSelect(e) {
    try {
      if (e.target.value === 'delete') {
        getData();
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      if (
        (searchData.length >= 1 || searchData.length === 0) &&
        firstTimeFetch
      ) {
        onSearch(searchData);
      }
    }, 700);

    return () => {
      clearTimeout(handler);
    };
  }, [searchData]);

  const onConfirmAlert = async () => {
    setLoader(true);
    try {
      const response = await deletePaymentReceiptService({ id: receiptData?.id });
      if (response?.success) {
        setIsAlertVisible(false);
        setModal('');
        setShow(false);
        modalNotification({
          type: 'success',
          message: t('text.report.receiptDeleted'),
        });
        onRefresh();
      }
      setLoader(false);
      return true;
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }

  useEffect(() => {
    setFirstTimeFetch(true);
  }, []);

  const handleReceiptUpload = async (values) => {
    const bodyData = {
      receipt: values?.receipt,
    };
    try {
      let response = await uploadPaymentReceiptService({
        bodyData,
        id: receiptData?.id,
      });
      if (response?.success) {
        setModal('');
        setShow(false);
        onRefresh();
      }
    } catch (error) {
      console.log(error)
    }
  };

  const modalObj = {
    mediaPreiview: (
      <MediaPreview setIsAlertVisible={setIsAlertVisible} receiptData={receiptData} />
    ),
    uploadReceipt: (
      <UploadReceipt onSubmit={handleReceiptUpload} receiptData={receiptData} />
    ),
  };
  return (
    <>
      <CustomTable
        tableData={data}
        searchDisabled={data?.length > 1 || searchData?.length}
        tableColumns={columns}
        count={count}
        setSearchData={setSearchData}
        setPage={setPage}
        sizePerPage={sizePerPage}
        currentPage={currentPage}
        tableLoader={isLoading}
        searchPlaceholder={t('text.common.searchMessage')}
        isModalPadding={true}
        hasLimit
        handleActionSelect={handleActionSelect}
        modalParams={false}
        showPageSizeAction={false}
      />
      <ModalWrapper
        onCancel={onCancel}
        extraClassName="modal-dialog-scrollable"
        content={modalObj[modal]}
        heading={modal === 'mediaPreiview' ? t('text.report.viewReceipt') : t('text.report.receiptUpload')}
        show={show}
      />
      <SweetAlert
        title={t('text.common.areYouSure')}
        text={t('text.report.youWantToDeleteReceipt')}
        show={isAlertVisible}
        icon="warning"
        showCancelButton
        confirmButtonText="Yes"
        cancelButtonText="No"
        setIsAlertVisible={setIsAlertVisible}
        showLoaderOnConfirm={loader}
        loading={loader}
        onConfirmAlert={onConfirmAlert}
      />
    </>
  );
}

export default SplitPaymentDetails;
